'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TableColumn=require('../../../../dist-es6/client/directives/sortableTableDirective/tableColumn');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

SortableTableDirective=function(_BaseControllerBacked){_inherits(SortableTableDirective,_BaseControllerBacked);function SortableTableDirective(){_classCallCheck(this,SortableTableDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}SortableTableDirective.prototype.





















































































































factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
return directive;
};_createClass(SortableTableDirective,[{key:'restrict',get:function(){return'E'}},{key:'objectBindings',get:function(){return['tableData','columnDefinitions','searchablePropertiesOnData','filteredTableData','onRowClick','currentFilter','context']}},{key:'textBindings',get:function(){return['headerRowClass','emptyArrayMessage','noSearchResultsMessage','itemTypeName','pluralItemTypeName','singleItemTypeName']}},{key:'template',get:function(){return function($elem,$attr){let searchBoxMarkup=`<pulsar-search class="table-filter"
                data="controller.tableData"
                searchable-properties="controller.searchablePropertiesOnData"
                current-filter="controller.currentFilter"
                filtered-data="controller.filteredTableData"
                debounce-rate="controller.searchDebounceRate" />`;let tableStartMarkup=`<table>
                    <thead>
                        <tr ng-class="controller.headerRowClass">
                            <td pulsar-column-header
                                data-ng-repeat="tableColumn in controller.tableColumns"
                                table-column="tableColumn"
                                sortable-table-controller="controller">
                            </td>
                        </tr>
                    </thead>
                ${$attr.showVerticalScrollbar==='true'?'</table><pulsar-scrollbar><div><table>':''}
                    <tbody>
                        <tr ng-if="controller.filteredTableData && controller.filteredTableData.length > 0"
                            data-ng-repeat="item in controller.filteredTableData | orderBy: controller.orderBy | filter: controller.filterToItemsStartingAtOrAfterIndex | limitTo: controller.itemsPerPage track by $index"
                            data-ng-class="{clickable: controller.onRowClick !== undefined}"
                            data-ng-click="controller.onRowClick(item, $event) || null">`;let template=searchBoxMarkup+tableStartMarkup;angular.forEach($elem.find('> div'),function(item){let columnString=item.outerHTML.replace(/^<div/i,'<td').replace(/<\/div>$/i,'</td>');template+=columnString});let tableEndMarkup=`</tr>
                        <tr data-ng-if="controller.filteredTableData.length === 0" class="empty">
                            <td colspan="{{controller.tableColumns.length}}">{{controller.currentFilter.length > 0 && controller.noSearchResultsMessage ? controller.noSearchResultsMessage : controller.emptyArrayMessage}}</td>
                        </tr>
                    </tbody>
                </table>
            ${$attr.showVerticalScrollbar==='true'?'</div><div class="clearfix"></div></pulsar-scrollbar>':''}
            <div class="pagination-container" ng-if="$root.Pulsar.lodash.exists(controller.pages) && controller.pages.length > 0">
                <ol class="page-navigation">
                    <li>
                        <span>{{controller.currentPageLabel}}</span>
                    </li>
                    <li ng-if="controller.pages.length > 1">
                        <button class="previous-page"
                            ng-disabled="controller.currentPageIndex === 0"
                            ng-click="controller.goToPage(controller.currentPageIndex - 1)"
                            alt="View Previous Page"
                            title="View Previous Page">
                            <img class="play-icon reverse" src="/images/Play.svg" />
                        </button>
                    </li>
                    <li class="first-page" ng-if="controller.pages.length > controller.numPagesToShow && controller.currentPageIndex >= controller.numPagesToShow - controller.numPagesToShowBeforeCurrent">
                        <button class="page-number"
                            ng-click="controller.goToPage(0)"
                            alt="View First Page"
                            title="View First Page">1</button>
                        <span>…</span>
                    </li>
                    <li ng-if="controller.pages.length > 1" data-ng-repeat="page in controller.pages | filter: controller.filterToPagesStartingNearPageIndex | limitTo: controller.numPagesToShow track by $index">
                        <button class="page-number"
                            ng-class="{selected: controller.currentPageIndex === page}"
                            ng-click="controller.goToPage(page)"
                            alt="View Page {{page + 1}}"
                            title="View Page {{page + 1}}">
                            {{page + 1}}
                        </button>
                    </li>
                    <li class="last-page" ng-if="controller.pages.length > controller.numPagesToShow && controller.currentPageIndex < controller.pages.length - controller.numPagesToShowBeforeCurrent - 1">
                        <span>…</span>
                        <button class="page-number"
                            ng-click="controller.goToPage(controller.pages[controller.pages.length - 1])"
                            alt="View Last Page"
                            title="View Last Page">{{controller.pages.length}}</button>
                    </li>
                    <li ng-if="controller.pages.length > 1">
                        <button class="next-page"
                            ng-disabled="controller.currentPageIndex === (controller.pages.length-1)"
                            ng-click="controller.goToPage(controller.currentPageIndex + 1)"
                            alt="View Next Page"
                            title="View Next Page">
                            <img class="play-icon" src="/images/Play.svg" />
                        </button>
                    </li>
                </ol>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>`;template+=tableEndMarkup;return template}}},{key:'controller',get:function(){return SortableTableDirectiveController}}]);return SortableTableDirective}(BaseControllerBackedDirective);let SortableTableDirectiveController=function(){_createClass(SortableTableDirectiveController,null,[{key:'$inject',get:function(){return['$scope','$timeout','$element']}}]);function SortableTableDirectiveController($scope,$timeout,$element){var _this2=this;_classCallCheck(this,SortableTableDirectiveController);this._$timeout=$timeout;this._$element=$element;this._tableColumns=this.columnDefinitions.map(function(columnDefinition){return _this2._getSortableColumn(columnDefinition)});this._activeColumn=_.find(this._tableColumns,{isActive:!0});if(!_.exists(this._activeColumn)){throw new Error('At least one column must have {isInitiallyActive: true} set.')}this.itemTypeName=this.itemTypeName||'Row';this._isInitialized=!1;this.itemsPerPage=10;this.numPagesToShow=5;this.currentPageIndex=0;this.searchDebounceRate=0;this.pages=[];this.currentFilter=this.currentFilter||'';this.numPagesToShowBeforeCurrent=Math.floor(this.numPagesToShow/2);this.filterToItemsStartingAtOrAfterIndex=this.filterToItemsStartingAtOrAfterIndex.bind(this);this.filterToPagesStartingNearPageIndex=this.filterToPagesStartingNearPageIndex.bind(this);$scope.$watch('controller.filteredTableData',function(filteredData){return _this2._updatePagination(filteredData)});this._updatePagination(this.data)}SortableTableDirectiveController.prototype._updatePagination=function _updatePagination(data){if(!_.exists(data)){return}this.pages=_.range(Math.ceil(data.length/this.itemsPerPage));this.goToPage(0);this._isInitialized=!0};SortableTableDirectiveController.prototype._getSortableColumn=function _getSortableColumn(columnDefinition){let{label:label,defaultAscending:defaultAscending,orderBy:orderBy,finalSort:finalSort,isInitiallyActive:isInitiallyActive,columnClass:columnClass}=columnDefinition;return new TableColumn(label,orderBy,defaultAscending,finalSort,isInitiallyActive,columnClass)};SortableTableDirectiveController.prototype.sortBy=function sortBy(tableColumn){var _this3=this;if(tableColumn.sortDisabled){return}this._$timeout(function(){for(let col of _this3._tableColumns){if(col===tableColumn){_this3._activeColumn=tableColumn;_this3._activeColumn.sort()}else{col.endSort()}}})};SortableTableDirectiveController.prototype.

goToPage=function goToPage(pageIndex){
this.currentPageIndex=pageIndex;
};SortableTableDirectiveController.prototype.

filterToItemsStartingAtOrAfterIndex=function filterToItemsStartingAtOrAfterIndex(item,index){
return index>=this.currentPageIndex*this.itemsPerPage;
};SortableTableDirectiveController.prototype.

filterToPagesStartingNearPageIndex=function filterToPagesStartingNearPageIndex(item,index){
return index>=this.pages.length-this.numPagesToShow||index>=this.currentPageIndex-this.numPagesToShowBeforeCurrent;
};SortableTableDirectiveController.prototype.





_getPluralizedItemTypeName=function _getPluralizedItemTypeName(){
return this.availableData.length===1?
this.singleItemTypeName||this.itemTypeName:
this.pluralItemTypeName||this.itemTypeName+'s';
};_createClass(SortableTableDirectiveController,[{key:'availableData',get:function(){return this.filteredTableData||this.tableData}},{key:'currentPageLabel',get:function()

{
const dataLength=this.availableData.length;
let pageStartItemIndex=this.currentPageIndex*this.itemsPerPage;
let numOnCurrentPage=this.currentPageIndex<this.pages.length-1?this.itemsPerPage:dataLength-pageStartItemIndex;
let pluralizedItemTypeName=this._getPluralizedItemTypeName();
return`${pageStartItemIndex+1}-${pageStartItemIndex+numOnCurrentPage} of ${dataLength} ${pluralizedItemTypeName}`;
}},{key:'orderBy',get:function()

{
return this._activeColumn.orderBy;
}},{key:'tableColumns',get:function()

{
return this._tableColumns;
}}]);return SortableTableDirectiveController}();


module.exports=SortableTableDirective;
module.exports.controller=SortableTableDirectiveController;
//# sourceMappingURL=sortableTableDirective.js.map
